module.exports = __webpack_public_path__ + "media/images/prof-36aa051ed229600700485f5b5b31df87.png";